module.exports = __webpack_public_path__ + "img/ideation_2.3295afed.png";